var getProductAttachments_gql_default = `
query GetProductAttachments($uid: ID!) {
  ProductAttachments(uid: $uid) {
    customer_group
    file
    file_ext
    name
    url
  }
}
`;
export {
  getProductAttachments_gql_default as default
};
